import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Routes, RouterModule} from '@angular/router';

import {AppComponent} from 'src/app/app.component';
import {AuthService} from 'src/app/utility/auth/auth.service';

import {
  MeteringDetailListComponent,
  MeteringDetailLogComponent,
  MeteringListComponent,
  StatisticsComponent,
} from '@serengeti/serengeti-metering';


const routes: Routes = [
  {
    path: 'main', component: AppComponent, canActivate: [AuthService], children: [
      { path: 'metering/list', component: MeteringListComponent, outlet: 'content', canActivate: [AuthService],
        data: { title: 'metering.title', root: true}},
      { path: 'metering/detail/:id', component: MeteringDetailListComponent, outlet: 'content', canActivate: [AuthService],
        data: { title: 'metering.detail.title', root: true}},
      { path: 'metering/detail/log/:id', component: MeteringDetailLogComponent, outlet: 'content', canActivate: [AuthService],
        data: { title: 'metering.detail.log', root: true}},
      { path: 'metering/statistics', component: StatisticsComponent, outlet: 'content', canActivate: [AuthService],
        data: { title: 'metering.statistics.title', root: true}},
    ]
  },
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload', useHash: true}),
    CommonModule
  ]
})
export class AppRoutingMeteringModule {
}
